import firebase from 'firebase/app'
import auth from '@/firebase/auth'
import db from '@/firebase/firestore'

const state = {
    settings: {},
}

const getters = {
    settings: (state) => state.settings,
}

const mutations = {
    ADD_SETTINGS: (state, payload) => {
        state.settings = payload
    },
    EDIT_SETTINGS: (state, payload) => {
        return state.settings
    },
}

const actions = {
    loadSettings: ({ commit }) => {
        auth
            .currentUser
            .getIdTokenResult()
            .then(userData => {
                db
                    .collection(`${userData.claims.db}/happinesssettings/settings`)
                    .get()
                    .then((querySnapshot) => {
                        const list = []
                        querySnapshot.forEach((doc) => {
                            list.push({
                                ...doc.data(),
                                uid: doc.id,
                            })
                        })

                        commit('ADD_SETTINGS', list[0])
                    })
                    .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'settings/index.js', 37, err))
            })
            .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'index.js', 44, err))
    },
    editSettings: ({ commit }, payload) => {
        const data = {
            ...payload.data,
            updatedUser: auth.currentUser.uid,
            updatedDate: firebase.firestore.FieldValue.serverTimestamp(),
        }

        auth
            .currentUser
            .getIdTokenResult()
            .then(async userData => {
                const settings = await db
                    .collection(`${userData.claims.db}/happinesssettings/settings`)
                    .doc('0')
                    .get()
                    .then((settings) => settings.data())
                    .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'index.js', 62, err))

                db
                    .collection(`${userData.claims.db}/happinesssettings/settings`)
                    .doc('0')
                    .set(data, { merge: true })
                    .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'index.js', 69, err))

                db
                    .collection(`happinesssettings/${settings.hour}/${userData.claims.db}`)
                    .doc('0')
                    .delete()
                    .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'index.js', 81, err))

                db
                    .collection(`happinesssettings/${data.hour}/${userData.claims.db}`)
                    .doc('0')
                    .set(data, { merge: true })
                    .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'index.js', 75, err))

                commit('EDIT_SETTINGS', data)
            })
            .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'index.js', 85, err))
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
